import { Box, CardContent } from "@mui/material";
import { Card } from "@src/appV2/redesign/system/ui-components";
import { useCallback, useState } from "react";

import FortuneCookieSvg from "./fortune-cookie.svg";

interface FortuneCookieListCardProps {
  onClick: () => void;
}

export function FortuneCookieListCard({ onClick }: FortuneCookieListCardProps) {
  const [isDisappearing, setIsDisappearing] = useState(false);

  const handleClick = useCallback(() => {
    setIsDisappearing(true);
    // Call the original onClick after a short delay to allow animation to start
    setTimeout(() => {
      onClick();
    }, 50);
  }, [onClick]);

  return (
    <Card
      variant="tertiary"
      sx={{
        position: "relative",
        overflow: "visible",
      }}
    >
      <CardContent>
        <Box
          component="button"
          aria-label="Open fortune cookie"
          sx={{
            position: "absolute",
            right: 8,
            transform: "translateY(-100%) rotate(-20deg)",
            padding: 3,
            border: "none",
            background: "transparent",
            cursor: "pointer",
            transition: isDisappearing
              ? "opacity 0.3s ease-out, transform 0.3s ease-out"
              : "transform 0.2s ease-in-out",
            opacity: isDisappearing ? 0 : 1,
            "@keyframes cookieSwing": {
              "0%, 100%": {
                transform: "translateY(-120%) rotate(-18deg)",
              },
              "50%": {
                transform: "translateY(-120%) rotate(-27deg)",
              },
            },
            animation: isDisappearing ? "none" : "cookieSwing 2s ease-in-out infinite",
            "& img": {
              width: "64px",
              display: "block",
            },
          }}
          onClick={handleClick}
        >
          <img src={FortuneCookieSvg} alt="Fortune Cookie" />
        </Box>
      </CardContent>
    </Card>
  );
}
